import '@angular/core';
import '@angular/common';
import '@angular/common/http';
import '@angular/router';
import { loadRemoteEntry } from '@angular-architects/module-federation';
import { environment } from './environments/environment';
import { initializeAgGrid } from './ag-grid.config';

const baseUrl = environment.GCU_SUBSCRIPTION_BASE_URL.replace('/remoteEntry.js', '');
const envJsUrl = `${baseUrl}/assets/env/env.js`;
(window as any).GCU_SUBSCRIPTION_ENV_URL = envJsUrl;
(document.getElementById('subscription-envjs') as HTMLScriptElement).src = envJsUrl;

Promise.all([
    loadRemoteEntry({ type: 'module', remoteEntry: environment.GCU_FOREX_BASE_URL }),
    loadRemoteEntry({ type: 'module', remoteEntry: environment.GCU_ECASH_BASE_URL }),
    loadRemoteEntry({ type: 'module', remoteEntry: environment.GCU_HABILITATION_BASE_URL }),
    loadRemoteEntry({ type: 'module', remoteEntry: environment.GCU_SUBSCRIPTION_BASE_URL }),
    loadRemoteEntry({ type: 'module', remoteEntry: environment.GCU_FASTNET_BASE_URL }),
    loadRemoteEntry({ type: 'module', remoteEntry: environment.GCU_CORPORATE_ACTIONS_BASE_URL }),
    loadRemoteEntry({ type: 'module', remoteEntry: environment.GCU_ESETTLEMENT_BASE_URL }),
])
    .catch((err) => console.error('Error loading remote entries', err))
    .then(() => initializeAgGrid())
    .then(() => import('./bootstrap'))
    .catch((err) => console.error(err));
